export default "question4cf1c0012170e601.svg"